function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrag = function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    fill: "none",
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M1 1h19M1 8h19M1 15h19"
  }));
};
export default SvgDrag;